import { render } from "./EquiposComputo.vue?vue&type=template&id=81df4d30&scoped=true"
import script from "./EquiposComputo.vue?vue&type=script&lang=js"
export * from "./EquiposComputo.vue?vue&type=script&lang=js"

import "./EquiposComputo.vue?vue&type=style&index=0&id=81df4d30&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81df4d30"]])

export default __exports__